import React from 'react';
import { Link } from 'react-router-dom';
import { Card, StatusBadge, EmptyState } from '@/components/ds';
import { Button } from '@/components/ui/button';
import { FolderTree, Plus, ChevronRight } from 'lucide-react';

/**
 * AgencyDownlineTree — replaces the "Downline Agencies" tab. Compact list of
 * direct child agencies with quick nav.
 */
export const AgencyDownlineTree = ({ childAgencies = [], canAddChild = false, agencyId }) => (
  <Card
    icon={FolderTree}
    title="Downline Agencies"
    description={`${childAgencies.length} direct sub-agenc${childAgencies.length === 1 ? 'y' : 'ies'}.`}
    headerActions={
      canAddChild && (
        <Link to={`/agencies?add_parent=${agencyId}`}>
          <Button size="sm" data-testid="add-sub-agency-btn">
            <Plus size={14} className="mr-1" /> Add Sub-Agency
          </Button>
        </Link>
      )
    }
    testId="agency-downline-tree"
  >
    {childAgencies.length === 0 ? (
      <EmptyState
        icon={FolderTree}
        title="No sub-agencies"
        description="This agency has no downline agencies."
      />
    ) : (
      <div className="space-y-1.5">
        {childAgencies.map((a) => (
          <Link
            key={a.agency_id}
            to={`/agencies/${a.agency_id}`}
            className="flex items-center justify-between p-2 -mx-2 rounded-md hover:bg-slate-50 transition-colors"
            data-testid={`downline-agency-${a.agency_id}`}
          >
            <div className="min-w-0 flex-1">
              <div className="text-sm font-medium truncate" style={{ color: 'var(--kr-navy-900)' }}>
                {a.agency_name}
              </div>
              <div className="text-[11px]" style={{ color: 'var(--kr-muted)' }}>
                {a.primary_contact_name || '—'} · Depth {a.depth}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <StatusBadge variant={a.status === 'active' ? 'success' : 'neutral'}>{a.status}</StatusBadge>
              <ChevronRight size={14} className="text-slate-400" />
            </div>
          </Link>
        ))}
      </div>
    )}
  </Card>
);

export default AgencyDownlineTree;
